import { Component, OnInit, EventEmitter } from '@angular/core';
import { Input ,Output} from '@angular/core';
import { TreeNodee } from '../../models/TreeNode.model';
import { JsonAdaptor } from '@syncfusion/ej2-data';
@Component({
  selector: 'app-tree-nodee',
  templateUrl: './tree-nodee.component.html',
  styleUrls: ['./tree-nodee.component.css']
})
export class TreeNodeeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  // @Output() nodeValue;
  @Output() nodeValue = new EventEmitter();
  @Input() treeData: TreeNodee[];
  nodeName;

  toggleChild(node) {
    node.showChildren = !node.showChildren;
  }

  open(node){
    //console.log("node name"+node);
    // this.nodeValue=node.Name;
    this.nodeValue.emit(node);
    //console.log("showchildren"+node.showChildren);
  }
  displayNode(event){
      this.nodeName=event;
      this.nodeValue.emit(this.nodeName);
    }
}
